import { IconMapTrain16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { railway as getRailway } from '../../utils/railway';
import { SpecialGeo } from '../SpecialGeo';
import { NBSP } from 'shared/constants/symbols';

import type { IOffer } from 'shared/offer';

interface IRailwayContainerProps {
  offer: IOffer;
}

export const RailwayContainer: React.FC<IRailwayContainerProps> = props => {
  const { offer } = props;
  const railway = getRailway(offer);

  const remoteness = React.useMemo(() => {
    if (railway && railway.time && railway.time > 0) {
      const unit = 'мин.';
      const transportType = railway.travelType === 'byFoot' ? 'пешком' : 'на транспорте';

      return `${railway.time}${NBSP}${unit} ${transportType}`;
    }

    return undefined;
  }, [railway]);

  if (!railway) {
    return null;
  }

  return (
    <SpecialGeo label={railway.name} icon={<IconMapTrain16 color="icon-secondary-default" />} remoteness={remoteness} />
  );
};
